var q = Object.defineProperty;
var Q = (i, t, e) => t in i ? q(i, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[t] = e;
var A = (i, t, e) => Q(i, typeof t != "symbol" ? t + "" : t, e);
import m from "axios";
const h = "https://infura.chargify.com".replace(/\/+$/, "");
class G {
  constructor(t, e = h, r = m) {
    A(this, "configuration");
    this.basePath = e, this.axios = r, t && (this.configuration = t, this.basePath = t.basePath || this.basePath);
  }
}
class $ extends Error {
  constructor(t, e) {
    super(e), this.field = t, this.name = "RequiredError";
  }
}
const C = "https://example.com", d = function(i, t, e) {
  if (e == null)
    throw new $(
      t,
      `Required parameter ${t} was null or undefined when calling ${i}.`
    );
}, y = function(i, t) {
  t && (t.username || t.password) && (i.auth = { username: t.username, password: t.password });
}, b = function(i, ...t) {
  const e = new URLSearchParams(i.search);
  for (const r of t)
    for (const s in r) {
      const a = r[s];
      typeof a == "object" ? Object.entries(a).forEach(([o, n]) => {
        e.set(`${s}[${o}]`, String(n));
      }) : e.set(s, a);
    }
  i.search = e.toString();
}, _ = function(i, t, e) {
  const r = typeof i != "string";
  return (r && e && e.isJsonMime ? e.isJsonMime(t.headers["Content-Type"]) : r) ? JSON.stringify(i !== void 0 ? i : {}) : i || "";
}, O = function(i) {
  return i.pathname + i.search + i.hash;
}, S = function(i, t, e, r) {
  return (s = t, a = e) => {
    const o = { ...i.options, url: ((r == null ? void 0 : r.basePath) || a) + i.url };
    return s.request(o);
  };
}, W = {
  AUTHORIZENET: "authorizenet",
  STRIPE: "stripe"
}, J = {
  BOGUS: "bogus",
  VISA: "visa",
  MASTER: "master",
  DISCOVER: "discover",
  AMERICAN_EXPRESS: "american_express",
  DINERS_CLUB: "diners_club",
  JCB: "jcb",
  SWITCH: "switch",
  SOLO: "solo",
  DANKORT: "dankort",
  MAESTRO: "maestro",
  LASER: "laser",
  FORBRUGSFORENINGEN: "forbrugsforeningen"
}, z = {
  FULL: "full",
  PRORATED: "prorated",
  NONE: "none"
}, X = {
  CARD: "card",
  BANK: "bank"
}, Z = {
  USD: "USD"
}, ee = {
  PER_UNIT: "per_unit",
  VOLUME: "volume",
  TIERED: "tiered",
  STAIRSTEP: "stairstep",
  NULL: "null"
}, te = {
  QUANTITY_BASED_COMPONENT: "quantity_based_component",
  METERED_COMPONENT: "metered_component",
  ON_OFF_COMPONENT: "on_off_component",
  PREPAID_USAGE_COMPONENT: "prepaid_usage_component"
}, se = {
  DO_NOT_RECUR: "do_not_recur",
  RECUR_INDEFINITELY: "recur_indefinitely",
  RECUR_WITH_DURATION: "recur_with_duration"
}, re = {
  COMPOUND: "compound",
  FULL_PRICE: "full-price",
  NULL: "null"
}, ae = {
  AMOUNT: "amount",
  PERCENT: "percent"
}, oe = {
  COMPONENT: "Component",
  PRODUCT: "Product"
}, ne = {
  BOGUS: "bogus",
  AUTHORIZENET: "authorizenet",
  TRUST_COMMERCE: "trust_commerce",
  PAYMENT_EXPRESS: "payment_express",
  BEANSTREAM: "beanstream",
  BRAINTREE_BLUE: "braintree_blue",
  PAYPAL: "paypal",
  QUICKPAY: "quickpay",
  EWAY: "eway",
  STRIPE: "stripe",
  WIRECARD: "wirecard",
  NULL: "null"
}, ie = {
  API_REQUESTS: "api-requests",
  REQUEST_PACKS: "request-packs"
}, ce = {
  CORE: "core",
  DEVELOPER: "developer",
  TEAM: "team",
  GROWTH: "growth",
  CUSTOM: "custom"
}, le = {
  API_REQUESTS_FREE: "api-requests-free"
}, pe = {
  CORE_FREE: "core-free"
}, de = {
  EGRESS: "egress",
  INGRESS: "ingress",
  STORAGE: "storage"
}, ue = {
  IPFS: "ipfs"
}, me = {
  ORIGINAL: "original"
}, he = {
  INFURA_FREE_PLANS: "infura-free-plans",
  INFURA_CORE: "infura-core",
  IPFS: "ipfs"
}, Pe = {
  AUTOMATIC: "automatic",
  REMITTANCE: "remittance"
}, Ce = {
  NONE: "none",
  CHILD: "child",
  PARENT: "parent"
}, ye = {
  DRAFT: "draft",
  PENDING: "pending",
  OPEN: "open",
  PAID: "paid",
  VOIDED: "voided",
  CANCELED: "canceled"
}, be = {
  BUSINESS_SOFTWARE: "Business Software",
  CONSUMER_SOFTWARE: "Consumer Software",
  DIGITAL_SERVICES: "Digital Services",
  PHYSICAL_GOODS: "Physical Goods",
  OTHER: "Other",
  NULL: "null"
}, Oe = {
  CUSTOMER_REFERENCE: "customer_reference",
  ACCOUNT_DAILY_REQUEST_RATE_LIMIT: "account_daily_request_rate_limit",
  DO_NOT_SYNC_TO_NETSUITE: "do_not_sync_to_netsuite",
  RATE_LIMIT_EXEMPTED: "rate_limit_exempted",
  USER_ON_A_PAID_SUBSCRIPTION: "user_on_a_paid_subscription"
}, Se = {
  AUTOMATIC: "automatic",
  INVOICE: "invoice"
}, Ve = {
  CREDIT_CARD: "credit_card",
  BANK_ACCOUNT: "bank_account"
}, Re = {
  DEFAULT: "default",
  CATALOG: "catalog",
  CUSTOM: "custom"
}, Ee = {
  PER_UNIT: "per_unit",
  VOLUME: "volume",
  TIERED: "tiered",
  STAIRSTEP: "stairstep",
  NULL: "null"
}, _e = {
  MONTH: "month",
  DAY: "day",
  NEVER: "never",
  NULL: "null"
}, Ae = {
  MONTH: "month",
  DAY: "day"
}, Ie = {
  MONTH: "month",
  DAY: "day",
  NULL: "null"
}, Ue = {
  MERCHANT_UI: "merchant_ui",
  MERCHANT_API: "merchant_api",
  DUNNING: "dunning",
  BILLING_PORTAL: "billing_portal",
  NULL: "null"
}, Te = {
  AUTOMATIC: "automatic",
  INVOICE: "invoice",
  REMITTANCE: "remittance",
  PREPAID: "prepaid",
  NULL: "null"
}, fe = {
  AUTOMATIC: "automatic",
  INVOICE: "invoice",
  REMITTANCE: "remittance",
  PREPAID: "prepaid",
  NULL: "null"
}, ve = {
  ACTIVE: "active",
  CANCELED: "canceled",
  EXPIRED: "expired",
  ON_HOLD: "on_hold",
  PAST_DUE: "past_due",
  SOFT_FAILURE: "soft_failure",
  TRIALING: "trialing",
  TRIAL_ENDED: "trial_ended",
  UNPAID: "unpaid",
  SUSPENDED: "suspended",
  AWAITING_SIGNUP: "awaiting_signup",
  ASSESSING: "assessing",
  FAILED_TO_CREATE: "failed_to_create",
  PAUSED: "paused",
  PENDING: "pending"
}, Ne = {
  AUTOMATIC: "automatic",
  INVOICE: "invoice",
  REMITTANCE: "remittance",
  PREPAID: "prepaid",
  NULL: "null"
}, Y = function(i) {
  return {
    /**
     * An existing subscription can accommodate multiple discounts/coupon codes. This is only applicable if each coupon is stackable. [Read more](https://developers.chargify.com/docs/api-docs/fea46972c2a88-add-coupons-to-subscription)
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {SubcriptionCouponInput} subcriptionCouponInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addCoupon: async (t, e, r = {}) => {
      d("addCoupon", "subscriptionId", t), d("addCoupon", "subcriptionCouponInput", e);
      const s = "/subscriptions/{subscription_id}/add_coupon.json".replace(
        "{subscription_id}",
        encodeURIComponent(String(t))
      ), a = new URL(s, C);
      let o;
      i && (o = i.baseOptions);
      const n = { method: "POST", ...o, ...r }, c = {}, l = {};
      y(n, i), c["Content-Type"] = "application/json", b(a, l);
      let p = o && o.headers ? o.headers : {};
      return n.headers = { ...c, ...p, ...r.headers }, n.data = _(e, n, i), {
        url: O(a),
        options: n
      };
    },
    /**
     * Creates multiple allocations, setting the current allocated quantity for each of the components and recording a memo. [Read more](https://developers.chargify.com/docs/api-docs/7d5adfebf33f3-allocate-components)
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {MultipleComponentAllocationInput} multipleComponentAllocationInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allocateComponents: async (t, e, r = {}) => {
      d("allocateComponents", "subscriptionId", t), d("allocateComponents", "multipleComponentAllocationInput", e);
      const s = "/subscriptions/{subscription_id}/allocations.json".replace(
        "{subscription_id}",
        encodeURIComponent(String(t))
      ), a = new URL(s, C);
      let o;
      i && (o = i.baseOptions);
      const n = { method: "POST", ...o, ...r }, c = {}, l = {};
      y(n, i), c["Content-Type"] = "application/json", b(a, l);
      let p = o && o.headers ? o.headers : {};
      return n.headers = { ...c, ...p, ...r.headers }, n.data = _(
        e,
        n,
        i
      ), {
        url: O(a),
        options: n
      };
    },
    /**
     * This action causes the cancellation of the Subscription. This means, the method sets the Subscription state to \"canceled\".
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {CancelSubscriptionInput} [cancelSubscriptionInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelSubscription: async (t, e, r = {}) => {
      d("cancelSubscription", "subscriptionId", t);
      const s = "/subscriptions/{subscription_id}.json".replace(
        "{subscription_id}",
        encodeURIComponent(String(t))
      ), a = new URL(s, C);
      let o;
      i && (o = i.baseOptions);
      const n = { method: "DELETE", ...o, ...r }, c = {}, l = {};
      y(n, i), c["Content-Type"] = "application/json", b(a, l);
      let p = o && o.headers ? o.headers : {};
      return n.headers = { ...c, ...p, ...r.headers }, n.data = _(
        e,
        n,
        i
      ), {
        url: O(a),
        options: n
      };
    },
    /**
     * This method allows to create new customers
     * @param {CustomerInput} customerInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCustomer: async (t, e = {}) => {
      d("createCustomer", "customerInput", t);
      const r = "/customers.json", s = new URL(r, C);
      let a;
      i && (a = i.baseOptions);
      const o = { method: "POST", ...a, ...e }, n = {}, c = {};
      y(o, i), n["Content-Type"] = "application/json", b(s, c);
      let l = a && a.headers ? a.headers : {};
      return o.headers = { ...n, ...l, ...e.headers }, o.data = _(t, o, i), {
        url: O(s),
        options: o
      };
    },
    /**
     * This method allows to create a payment profile for a customer using chargify_token.
     * @param {PaymentProfileInput} paymentProfileInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPaymentProfile: async (t, e = {}) => {
      d("createPaymentProfile", "paymentProfileInput", t);
      const r = "/payment_profiles.json", s = new URL(r, C);
      let a;
      i && (a = i.baseOptions);
      const o = { method: "POST", ...a, ...e }, n = {}, c = {};
      y(o, i), n["Content-Type"] = "application/json", b(s, c);
      let l = a && a.headers ? a.headers : {};
      return o.headers = { ...n, ...l, ...e.headers }, o.data = _(t, o, i), {
        url: O(s),
        options: o
      };
    },
    /**
     * This method allows to create new subscription.
     * @param {SubscriptionInput} subscriptionInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSubscription: async (t, e = {}) => {
      d("createSubscription", "subscriptionInput", t);
      const r = "/subscriptions.json", s = new URL(r, C);
      let a;
      i && (a = i.baseOptions);
      const o = { method: "POST", ...a, ...e }, n = {}, c = {};
      y(o, i), n["Content-Type"] = "application/json", b(s, c);
      let l = a && a.headers ? a.headers : {};
      return o.headers = { ...n, ...l, ...e.headers }, o.data = _(t, o, i), {
        url: O(s),
        options: o
      };
    },
    /**
     * This method allows to delete the Customer.
     * @param {number} id Chargify customer\&#39;s ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCustomer: async (t, e = {}) => {
      d("deleteCustomer", "id", t);
      const r = "/customers/{id}.json".replace("{id}", encodeURIComponent(String(t))), s = new URL(r, C);
      let a;
      i && (a = i.baseOptions);
      const o = { method: "DELETE", ...a, ...e }, n = {}, c = {};
      y(o, i), b(s, c);
      let l = a && a.headers ? a.headers : {};
      return o.headers = { ...n, ...l, ...e.headers }, {
        url: O(s),
        options: o
      };
    },
    /**
     * Deletes an unused payment profile. (Read more.)[https://developers.chargify.com/docs/api-docs/eaf0053209dfa-delete-unused-payment-profile]
     * @param {number} paymentProfileId Chargify payment profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePaymentProfile: async (t, e = {}) => {
      d("deletePaymentProfile", "paymentProfileId", t);
      const r = "/payment_profiles/{payment_profile_id}.json".replace(
        "{payment_profile_id}",
        encodeURIComponent(String(t))
      ), s = new URL(r, C);
      let a;
      i && (a = i.baseOptions);
      const o = { method: "DELETE", ...a, ...e }, n = {}, c = {};
      y(o, i), b(s, c);
      let l = a && a.headers ? a.headers : {};
      return o.headers = { ...n, ...l, ...e.headers }, {
        url: O(s),
        options: o
      };
    },
    /**
     * This request will by default list all customers associated with your Site. [Read more](https://developers.chargify.com/docs/api-docs/3fb9201a18426-list-or-find-customers)
     * @param {string} q Search query parameter to retrieve an array of customers that matches the search query. Search by:- an email, Chargify ID, organisation, first or last name, reference value from your application.
     * @param {number} [page] Result records are organized in pages. By default, the first page of results is displayed. The page parameter specifies a page number of results to fetch. You can start navigating through the pages to consume the results. You do this by passing in a page parameter. Retrieve the next page by adding ?page&#x3D;2 to the query string. If there are no results to return, then an empty result set will be returned.
     * @param {number} [perPage] This parameter indicates how many records to fetch in each request. Default value is 50. The maximum allowed values is 200; any per_page value over 200 will be changed to 200.
     * @param {'created_at' | 'updated_at'} [dateField] The type of filter you would like to apply to your search
     * @param {'asc' | 'desc'} [direction] The sort direction of the returned invoices.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findCustomers: async (t, e, r, s, a, o = {}) => {
      d("findCustomers", "q", t);
      const n = "/customers.json", c = new URL(n, C);
      let l;
      i && (l = i.baseOptions);
      const p = { method: "GET", ...l, ...o }, R = {}, u = {};
      y(p, i), t !== void 0 && (u.q = t), e !== void 0 && (u.page = e), r !== void 0 && (u.per_page = r), s !== void 0 && (u.date_field = s), a !== void 0 && (u.direction = a), b(c, u);
      let E = l && l.headers ? l.headers : {};
      return p.headers = { ...R, ...E, ...o.headers }, {
        url: O(c),
        options: p
      };
    },
    /**
     * This method allows to retrieve the Customer properties by Chargify-generated Customer ID.
     * @param {number} id Chargify customer\&#39;s ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomer: async (t, e = {}) => {
      d("getCustomer", "id", t);
      const r = "/customers/{id}.json".replace("{id}", encodeURIComponent(String(t))), s = new URL(r, C);
      let a;
      i && (a = i.baseOptions);
      const o = { method: "GET", ...a, ...e }, n = {}, c = {};
      y(o, i), b(s, c);
      let l = a && a.headers ? a.headers : {};
      return o.headers = { ...n, ...l, ...e.headers }, {
        url: O(s),
        options: o
      };
    },
    /**
     * Use this method to return the customer object if you have the unique Reference ID (Your App) value handy. It will return a single match.
     * @param {string} reference Infura\&#39;s chargify customer reference. Value is Infura user\&#39;s Id &#x60;{user.id}&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomerByReference: async (t, e = {}) => {
      d("getCustomerByReference", "reference", t);
      const r = "/customers/lookup.json", s = new URL(r, C);
      let a;
      i && (a = i.baseOptions);
      const o = { method: "GET", ...a, ...e }, n = {}, c = {};
      y(o, i), t !== void 0 && (c.reference = t), b(s, c);
      let l = a && a.headers ? a.headers : {};
      return o.headers = { ...n, ...l, ...e.headers }, {
        url: O(s),
        options: o
      };
    },
    /**
     * This method returns invoices for a specific customer. By default, invoices returned on the index will only include `totals`, not detailed breakdowns for `line_items`, `discounts`, `taxes`, `credits`, `payments`, `custom_fields`, or `refunds`. To include breakdowns, pass the specific field as a key in the query with a value set to `true`.
     * @param {string} customerIds Allows fetching invoices with matching customer id based on provided values.
     * @param {number} [page] Result records are organized in pages. By default, the first page of results is displayed. The page parameter specifies a page number of results to fetch. You can start navigating through the pages to consume the results. You do this by passing in a page parameter. Retrieve the next page by adding ?page&#x3D;2 to the query string. If there are no results to return, then an empty result set will be returned.
     * @param {number} [perPage] This parameter indicates how many records to fetch in each request. Default value is 20. The maximum allowed values is 200; any per_page value over 200 will be changed to 200.
     * @param {number} [subscriptionId] The subscription\&#39;s ID.
     * @param {'created_at' | 'due_date' | 'issue_date' | 'updated_at' | 'paid_date'} [dateField] The type of filter you would like to apply to your search
     * @param {boolean} [lineItems] Include line items data
     * @param {'asc' | 'desc'} [direction] The sort direction of the returned invoices.
     * @param {boolean} [credits] Include credits data
     * @param {boolean} [customFields] Include custom fields data
     * @param {boolean} [discounts] Include discounts data
     * @param {string} [endDate] The end date (format &#x60;YYYY-MM-DD&#x60;) with which to filter the date_field. Returns invoices with a timestamp up to and including 11:59:59PM in your site\&#39;s time zone on the date specified.
     * @param {string} [endDatetime] The end date and time (format &#x60;YYYY-MM-DD HH:MM:SS&#x60;) with which to filter the date_field. Returns invoices with a timestamp at or before exact time provided in query. You can specify timezone in query - otherwise your site\&#39;s time zone will be used. If provided, this parameter will be used instead of end_date. Allowed to be used only along with date_field set to created_at or updated_at.
     * @param {string} [number] Include custom fields data
     * @param {boolean} [payments] Include payments data
     * @param {string} [productIds] Allows fetching invoices with matching line items product ids based on provided values.
     * @param {boolean} [refunds] Include refunds data
     * @param {'status' | 'total_amount' | 'due_amount' | 'created_at' | 'updated_at' | 'issue_date' | 'due_date' | 'number'} [sort] Allows specification of the order of the returned list.
     * @param {string} [startDate] The start date (format &#x60;YYYY-MM-DD&#x60;) with which to filter the date_field. Returns invoices with a timestamp at or after midnight (&#x60;12:00:00 AM&#x60;) in your site\&#39;s time zone on the date specified.
     * @param {string} [startDatetime] The start date and time (format &#x60;YYYY-MM-DD HH:MM:SS&#x60;&#x60;) with which to filter the date_field. Returns invoices with a timestamp at or after exact time provided in query. You can specify timezone in query - otherwise your site\&#39;s time zone will be used. If provided, this parameter will be used instead of start_date. Allowed to be used only along with date_field set to created_at or updated_at.
     * @param {InvoiceStatus} [status] The current status of the invoice.
     * @param {string} [subscriptionGroupUid] The UID of the subscription group you want to fetch consolidated invoices for. This will return a paginated list of consolidated invoices for the specified group.
     * @param {boolean} [taxes] Include taxes data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomerInvoices: async (t, e, r, s, a, o, n, c, l, p, R, u, E, I, U, T, f, v, N, L, w, B, j = {}) => {
      d("getCustomerInvoices", "customerIds", t);
      const F = "/invoices.json", g = new URL(F, C);
      let D;
      i && (D = i.baseOptions);
      const M = { method: "GET", ...D, ...j }, H = {}, V = {};
      y(M, i), t !== void 0 && (V.customer_ids = t), e !== void 0 && (V.page = e), r !== void 0 && (V.per_page = r), s !== void 0 && (V.subscription_id = s), a !== void 0 && (V.date_field = a), o !== void 0 && (V.line_items = o), n !== void 0 && (V.direction = n), c !== void 0 && (V.credits = c), l !== void 0 && (V.custom_fields = l), p !== void 0 && (V.discounts = p), R !== void 0 && (V.end_date = R), u !== void 0 && (V.end_datetime = u), E !== void 0 && (V.number = E), I !== void 0 && (V.payments = I), U !== void 0 && (V.product_ids = U), T !== void 0 && (V.refunds = T), f !== void 0 && (V.sort = f), v !== void 0 && (V.start_date = v), N !== void 0 && (V.start_datetime = N), L !== void 0 && (V.status = L), w !== void 0 && (V.subscription_group_uid = w), B !== void 0 && (V.taxes = B), b(g, V);
      let x = D && D.headers ? D.headers : {};
      return M.headers = { ...H, ...x, ...j.headers }, {
        url: O(g),
        options: M
      };
    },
    /**
     * This method lists all subscriptions that belong to a customer.
     * @param {number} id Chargify customer\&#39;s ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomerSubscriptions: async (t, e = {}) => {
      d("getCustomerSubscriptions", "id", t);
      const r = "/customers/{id}/subscriptions.json".replace("{id}", encodeURIComponent(String(t))), s = new URL(r, C);
      let a;
      i && (a = i.baseOptions);
      const o = { method: "GET", ...a, ...e }, n = {}, c = {};
      y(o, i), b(s, c);
      let l = a && a.headers ? a.headers : {};
      return o.headers = { ...n, ...l, ...e.headers }, {
        url: O(s),
        options: o
      };
    },
    /**
     * This method retrieves a Payment Profile identified by its unique ID.
     * @param {number} paymentProfileId Chargify payment profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentProfile: async (t, e = {}) => {
      d("getPaymentProfile", "paymentProfileId", t);
      const r = "/payment_profiles/{payment_profile_id}.json".replace(
        "{payment_profile_id}",
        encodeURIComponent(String(t))
      ), s = new URL(r, C);
      let a;
      i && (a = i.baseOptions);
      const o = { method: "GET", ...a, ...e }, n = {}, c = {};
      y(o, i), b(s, c);
      let l = a && a.headers ? a.headers : {};
      return o.headers = { ...n, ...l, ...e.headers }, {
        url: O(s),
        options: o
      };
    },
    /**
     * Use this endpoint to read current price points that are associated with a component
     * @param {ChargifyComponentIDInput} componentId
     * @param {boolean} [currencyPrices] Include an array of currency price data
     * @param {GetPricePointsByComponentIdFilterParameter} [filter]
     * @param {number} [page] Result records are organized in pages. By default, the first page of results is displayed. The page parameter specifies a page number of results to fetch. You can start navigating through the pages to consume the results. You do this by passing in a page parameter. Retrieve the next page by adding ?page&#x3D;2 to the query string. If there are no results to return, then an empty result set will be returned.
     * @param {number} [perPage] This parameter indicates how many records to fetch in each request. Default value is 20. The maximum allowed values is 200; any per_page value over 200 will be changed to 200.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPricePointsByComponentId: async (t, e, r, s, a, o = {}) => {
      d("getPricePointsByComponentId", "componentId", t);
      const n = "/components/{component_id}/price_points.json".replace(
        "{component_id}",
        encodeURIComponent(String(t))
      ), c = new URL(n, C);
      let l;
      i && (l = i.baseOptions);
      const p = { method: "GET", ...l, ...o }, R = {}, u = {};
      y(p, i), e !== void 0 && (u.currency_prices = e), r !== void 0 && (u.filter = r), s !== void 0 && (u.page = s), a !== void 0 && (u.per_page = a), b(c, u);
      let E = l && l.headers ? l.headers : {};
      return p.headers = { ...R, ...E, ...o.headers }, {
        url: O(c),
        options: p
      };
    },
    /**
     * Use this endpoint to find a subscription by its reference.
     * @param {string} reference Subscription reference. Usually in this shape &#x60;infura_{user.id}&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscription: async (t, e = {}) => {
      d("getSubscription", "reference", t);
      const r = "/subscriptions/lookup.json", s = new URL(r, C);
      let a;
      i && (a = i.baseOptions);
      const o = { method: "GET", ...a, ...e }, n = {}, c = {};
      y(o, i), t !== void 0 && (c.reference = t), b(s, c);
      let l = a && a.headers ? a.headers : {};
      return o.headers = { ...n, ...l, ...e.headers }, {
        url: O(s),
        options: o
      };
    },
    /**
     * Use this endpoint to find a subscription by its reference.
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {'coupons'} include The coupon code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionById: async (t, e, r = {}) => {
      d("getSubscriptionById", "subscriptionId", t), d("getSubscriptionById", "include", e);
      const s = "/subscriptions/{subscription_id}.json".replace(
        "{subscription_id}",
        encodeURIComponent(String(t))
      ), a = new URL(s, C);
      let o;
      i && (o = i.baseOptions);
      const n = { method: "GET", ...o, ...r }, c = {}, l = {};
      y(n, i), e !== void 0 && (l["include[]"] = e), b(a, l);
      let p = o && o.headers ? o.headers : {};
      return n.headers = { ...c, ...p, ...r.headers }, {
        url: O(a),
        options: n
      };
    },
    /**
     * This endpoint returns the 50 most recent Allocations of the specified component to a subscription, ordered by most recent first. [Read more](https://developers.chargify.com/docs/api-docs/f70716b0e80f1-list-allocations)
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {ChargifyComponentIDInput} componentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listComponentAllocations: async (t, e, r = {}) => {
      d("listComponentAllocations", "subscriptionId", t), d("listComponentAllocations", "componentId", e);
      const s = "/subscriptions/{subscription_id}/components/{component_id}/allocations.json".replace("{subscription_id}", encodeURIComponent(String(t))).replace("{component_id}", encodeURIComponent(String(e))), a = new URL(s, C);
      let o;
      i && (o = i.baseOptions);
      const n = { method: "GET", ...o, ...r }, c = {}, l = {};
      y(n, i), b(a, l);
      let p = o && o.headers ? o.headers : {};
      return n.headers = { ...c, ...p, ...r.headers }, {
        url: O(a),
        options: n
      };
    },
    /**
     * This method will return a list of components for a particular product family.
     * @param {number} productFamilyId The product family ID
     * @param {number} [page] Result records are organized in pages. By default, the first page of results is displayed. The page parameter specifies a page number of results to fetch. You can start navigating through the pages to consume the results. You do this by passing in a page parameter. Retrieve the next page by adding ?page&#x3D;2 to the query string. If there are no results to return, then an empty result set will be returned.
     * @param {number} [perPage] This parameter indicates how many records to fetch in each request. Default value is 20. The maximum allowed values is 200; any per_page value over 200 will be changed to 200.
     * @param {boolean} [includeArchived] Include archived items.
     * @param {ListComponentsByProductFamilyIdFilterParameter} [filter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listComponentsByProductFamilyId: async (t, e, r, s, a, o = {}) => {
      d("listComponentsByProductFamilyId", "productFamilyId", t);
      const n = "/product_families/{productFamilyId}/components.json".replace(
        "{productFamilyId}",
        encodeURIComponent(String(t))
      ), c = new URL(n, C);
      let l;
      i && (l = i.baseOptions);
      const p = { method: "GET", ...l, ...o }, R = {}, u = {};
      y(p, i), e !== void 0 && (u.page = e), r !== void 0 && (u.per_page = r), s !== void 0 && (u.include_archived = s), a !== void 0 && (u.filter = a), b(c, u);
      let E = l && l.headers ? l.headers : {};
      return p.headers = { ...R, ...E, ...o.headers }, {
        url: O(c),
        options: p
      };
    },
    /**
     * This method will return all of the ACTIVE `payment_profiles` for one Customer within a site. If no payment profiles are found, this endpoint will return an empty array, not a 404.
     * @param {number} customerId Chargify customer ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCustomerActivePaymentProfiles: async (t, e = {}) => {
      d("listCustomerActivePaymentProfiles", "customerId", t);
      const r = "/payment_profiles.json", s = new URL(r, C);
      let a;
      i && (a = i.baseOptions);
      const o = { method: "GET", ...a, ...e }, n = {}, c = {};
      y(o, i), t !== void 0 && (c.customer_id = t), b(s, c);
      let l = a && a.headers ? a.headers : {};
      return o.headers = { ...n, ...l, ...e.headers }, {
        url: O(s),
        options: o
      };
    },
    /**
     * This method allows to retrieve a list of Products belonging to a Site
     * @param {number} [page] Result records are organized in pages. By default, the first page of results is displayed. The page parameter specifies a page number of results to fetch. You can start navigating through the pages to consume the results. You do this by passing in a page parameter. Retrieve the next page by adding ?page&#x3D;2 to the query string. If there are no results to return, then an empty result set will be returned.
     * @param {number} [perPage] This parameter indicates how many records to fetch in each request. Default value is 20. The maximum allowed values is 200; any per_page value over 200 will be changed to 200.
     * @param {boolean} [includeArchived] Include archived products.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listProducts: async (t, e, r, s = {}) => {
      const a = "/products.json", o = new URL(a, C);
      let n;
      i && (n = i.baseOptions);
      const c = { method: "GET", ...n, ...s }, l = {}, p = {};
      y(c, i), t !== void 0 && (p.page = t), e !== void 0 && (p.per_page = e), r !== void 0 && (p.include_archived = r), b(o, p);
      let R = n && n.headers ? n.headers : {};
      return c.headers = { ...l, ...R, ...s.headers }, {
        url: O(o),
        options: c
      };
    },
    /**
     * This method will return a list customer\'s subscriptions from a Site.
     * @param {ListSubscriptionsByCustomerReferenceMetadataParameter} metadata
     * @param {SubscriptionState} [state]
     * @param {'updated_at' | 'created_at'} [sort]
     * @param {number} [page] Result records are organized in pages. By default, the first page of results is displayed. The page parameter specifies a page number of results to fetch. You can start navigating through the pages to consume the results. You do this by passing in a page parameter. Retrieve the next page by adding ?page&#x3D;2 to the query string. If there are no results to return, then an empty result set will be returned.
     * @param {number} [perPage] This parameter indicates how many records to fetch in each request. Default value is 20. The maximum allowed values is 200; any per_page value over 200 will be changed to 200.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listSubscriptionsByCustomerReference: async (t, e, r, s, a, o = {}) => {
      d("listSubscriptionsByCustomerReference", "metadata", t);
      const n = "/subscriptions.json", c = new URL(n, C);
      let l;
      i && (l = i.baseOptions);
      const p = { method: "GET", ...l, ...o }, R = {}, u = {};
      y(p, i), t !== void 0 && (u.metadata = t), e !== void 0 && (u.state = e), r !== void 0 && (u.sort = r), s !== void 0 && (u.page = s), a !== void 0 && (u.per_page = a), b(c, u);
      let E = l && l.headers ? l.headers : {};
      return p.headers = { ...R, ...E, ...o.headers }, {
        url: O(c),
        options: p
      };
    },
    /**
     * Subscriptions should be in the `active` or `trialing` state in order to be migrated. [Read more](https://developers.chargify.com/docs/api-docs/c6f96f0245a2d-migrate-subscription-product)
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {MigrateSubscriptionInput} migrateSubscriptionInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    migrateSubscription: async (t, e, r = {}) => {
      d("migrateSubscription", "subscriptionId", t), d("migrateSubscription", "migrateSubscriptionInput", e);
      const s = "/subscriptions/{subscription_id}/migrations.json".replace(
        "{subscription_id}",
        encodeURIComponent(String(t))
      ), a = new URL(s, C);
      let o;
      i && (o = i.baseOptions);
      const n = { method: "POST", ...o, ...r }, c = {}, l = {};
      y(n, i), c["Content-Type"] = "application/json", b(a, l);
      let p = o && o.headers ? o.headers : {};
      return n.headers = { ...c, ...p, ...r.headers }, n.data = _(
        e,
        n,
        i
      ), {
        url: O(a),
        options: n
      };
    },
    /**
     * Preview the creation of a new subscription without creating it.
     * @param {SubscriptionInput} subscriptionInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    previewSubscription: async (t, e = {}) => {
      d("previewSubscription", "subscriptionInput", t);
      const r = "/subscriptions/preview.json", s = new URL(r, C);
      let a;
      i && (a = i.baseOptions);
      const o = { method: "POST", ...a, ...e }, n = {}, c = {};
      y(o, i), n["Content-Type"] = "application/json", b(s, c);
      let l = a && a.headers ? a.headers : {};
      return o.headers = { ...n, ...l, ...e.headers }, o.data = _(t, o, i), {
        url: O(s),
        options: o
      };
    },
    /**
     * Use this endpoint to remove a coupon from an existing subscription. [Read more](https://developers.chargify.com/docs/api-docs/4ba9e0490364e-remove-coupon-from-subscription)
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {string} couponCode The coupon code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeCoupon: async (t, e, r = {}) => {
      d("removeCoupon", "subscriptionId", t), d("removeCoupon", "couponCode", e);
      const s = "/subscriptions/{subscription_id}/remove_coupon.json".replace(
        "{subscription_id}",
        encodeURIComponent(String(t))
      ), a = new URL(s, C);
      let o;
      i && (o = i.baseOptions);
      const n = { method: "DELETE", ...o, ...r }, c = {}, l = {};
      y(n, i), e !== void 0 && (l.coupon_code = e), b(a, l);
      let p = o && o.headers ? o.headers : {};
      return n.headers = { ...c, ...p, ...r.headers }, {
        url: O(a),
        options: n
      };
    },
    /**
     * Use this endpoint to retry a canceled Chargify subscription. [Read more](https://developers.chargify.com/docs/api-docs/4ba9e0490364e-retry-subscription)
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retrySubscription: async (t, e = {}) => {
      d("retrySubscription", "subscriptionId", t);
      const r = "/subscriptions/{subscription_id}/retry.json".replace(
        "{subscription_id}",
        encodeURIComponent(String(t))
      ), s = new URL(r, C);
      let a;
      i && (a = i.baseOptions);
      const o = { method: "PUT", ...a, ...e }, n = {}, c = {};
      y(o, i), b(s, c);
      let l = a && a.headers ? a.headers : {};
      return o.headers = { ...n, ...l, ...e.headers }, {
        url: O(s),
        options: o
      };
    },
    /**
     * This method allows to update the Customer.
     * @param {number} id Chargify customer\&#39;s ID
     * @param {CustomerInput} customerInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCustomer: async (t, e, r = {}) => {
      d("updateCustomer", "id", t), d("updateCustomer", "customerInput", e);
      const s = "/customers/{id}.json".replace("{id}", encodeURIComponent(String(t))), a = new URL(s, C);
      let o;
      i && (o = i.baseOptions);
      const n = { method: "PUT", ...o, ...r }, c = {}, l = {};
      y(n, i), c["Content-Type"] = "application/json", b(a, l);
      let p = o && o.headers ? o.headers : {};
      return n.headers = { ...c, ...p, ...r.headers }, n.data = _(e, n, i), {
        url: O(a),
        options: n
      };
    },
    /**
     * This request will update any metadata belonging to a particular resource (ie. subscription, customer) that is specified.
     * @param {'customers' | 'subscriptions'} resourceType Chargify resource (ie. subscription, customer)
     * @param {number} resourceId Chargify payment profile ID
     * @param {MetadataInput} metadataInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateMetadata: async (t, e, r, s = {}) => {
      d("updateMetadata", "resourceType", t), d("updateMetadata", "resourceId", e), d("updateMetadata", "metadataInput", r);
      const a = "/{resource_type}/{resource_id}/metadata.json".replace("{resource_type}", encodeURIComponent(String(t))).replace("{resource_id}", encodeURIComponent(String(e))), o = new URL(a, C);
      let n;
      i && (n = i.baseOptions);
      const c = { method: "PUT", ...n, ...s }, l = {}, p = {};
      y(c, i), l["Content-Type"] = "application/json", b(o, p);
      let R = n && n.headers ? n.headers : {};
      return c.headers = { ...l, ...R, ...s.headers }, c.data = _(r, c, i), {
        url: O(o),
        options: c
      };
    },
    /**
     * (Read more.)[https://developers.chargify.com/docs/api-docs/6f6e08831dee5-update-payment-profile]
     * @param {number} paymentProfileId Chargify payment profile ID
     * @param {UpdateBillingInfoInput} updateBillingInfoInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePaymentProfile: async (t, e, r = {}) => {
      d("updatePaymentProfile", "paymentProfileId", t), d("updatePaymentProfile", "updateBillingInfoInput", e);
      const s = "/payment_profiles/{payment_profile_id}.json".replace(
        "{payment_profile_id}",
        encodeURIComponent(String(t))
      ), a = new URL(s, C);
      let o;
      i && (o = i.baseOptions);
      const n = { method: "PUT", ...o, ...r }, c = {}, l = {};
      y(n, i), c["Content-Type"] = "application/json", b(a, l);
      let p = o && o.headers ? o.headers : {};
      return n.headers = { ...c, ...p, ...r.headers }, n.data = _(e, n, i), {
        url: O(a),
        options: n
      };
    },
    /**
     * The subscription endpoint allows you to instantly update one or many attributes about a subscription in a single call.
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {UpdateSubscriptionInput} updateSubscriptionInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSubscription: async (t, e, r = {}) => {
      d("updateSubscription", "subscriptionId", t), d("updateSubscription", "updateSubscriptionInput", e);
      const s = "/subscriptions/{subscription_id}.json".replace(
        "{subscription_id}",
        encodeURIComponent(String(t))
      ), a = new URL(s, C);
      let o;
      i && (o = i.baseOptions);
      const n = { method: "PUT", ...o, ...r }, c = {}, l = {};
      y(n, i), c["Content-Type"] = "application/json", b(a, l);
      let p = o && o.headers ? o.headers : {};
      return n.headers = { ...c, ...p, ...r.headers }, n.data = _(
        e,
        n,
        i
      ), {
        url: O(a),
        options: n
      };
    },
    /**
     * This will change the default payment profile on the subscription to the existing payment profile with the id specified. You must elect to change the existing payment profile to a new payment profile ID in order to receive a satisfactory response from this endpoint. [Read more](https://developers.chargify.com/docs/api-docs/55c36d1e77566-change-subscription-default-payment-profile)
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {number} paymentProfileId The Chargify ID of the payment profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSubscriptionPaymentProfile: async (t, e, r = {}) => {
      d("updateSubscriptionPaymentProfile", "subscriptionId", t), d("updateSubscriptionPaymentProfile", "paymentProfileId", e);
      const s = "/subscriptions/{subscription_id}/payment_profiles/{payment_profile_id}/change_payment_profile.json".replace("{subscription_id}", encodeURIComponent(String(t))).replace("{payment_profile_id}", encodeURIComponent(String(e))), a = new URL(s, C);
      let o;
      i && (o = i.baseOptions);
      const n = { method: "POST", ...o, ...r }, c = {}, l = {};
      y(n, i), b(a, l);
      let p = o && o.headers ? o.headers : {};
      return n.headers = { ...c, ...p, ...r.headers }, {
        url: O(a),
        options: n
      };
    },
    /**
     * This method is useful for validating coupon codes that are entered by a customer.
     * @param {string} code The code of the coupon
     * @param {string} [productFamilyId] The Chargify id or handle of the product family to which the coupon belongs. Product family handle can be used in the product_family_id field, all that\&#39;s needed is a \&quot;handle:\&quot; prefix. For example, if your product_family_id\&#39;s handle is \&quot;infura-core\&quot;, the value in product_family_id would be \&quot;handle:infura-core\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    validateCoupon: async (t, e, r = {}) => {
      d("validateCoupon", "code", t);
      const s = "/coupons/validate.json", a = new URL(s, C);
      let o;
      i && (o = i.baseOptions);
      const n = { method: "GET", ...o, ...r }, c = {}, l = {};
      y(n, i), t !== void 0 && (l.code = t), e !== void 0 && (l.product_family_id = e), b(a, l);
      let p = o && o.headers ? o.headers : {};
      return n.headers = { ...c, ...p, ...r.headers }, {
        url: O(a),
        options: n
      };
    }
  };
}, P = function(i) {
  const t = Y(i);
  return {
    /**
     * An existing subscription can accommodate multiple discounts/coupon codes. This is only applicable if each coupon is stackable. [Read more](https://developers.chargify.com/docs/api-docs/fea46972c2a88-add-coupons-to-subscription)
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {SubcriptionCouponInput} subcriptionCouponInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addCoupon(e, r, s) {
      const a = await t.addCoupon(
        e,
        r,
        s
      );
      return S(a, m, h, i);
    },
    /**
     * Creates multiple allocations, setting the current allocated quantity for each of the components and recording a memo. [Read more](https://developers.chargify.com/docs/api-docs/7d5adfebf33f3-allocate-components)
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {MultipleComponentAllocationInput} multipleComponentAllocationInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async allocateComponents(e, r, s) {
      const a = await t.allocateComponents(
        e,
        r,
        s
      );
      return S(a, m, h, i);
    },
    /**
     * This action causes the cancellation of the Subscription. This means, the method sets the Subscription state to \"canceled\".
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {CancelSubscriptionInput} [cancelSubscriptionInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cancelSubscription(e, r, s) {
      const a = await t.cancelSubscription(
        e,
        r,
        s
      );
      return S(a, m, h, i);
    },
    /**
     * This method allows to create new customers
     * @param {CustomerInput} customerInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createCustomer(e, r) {
      const s = await t.createCustomer(e, r);
      return S(s, m, h, i);
    },
    /**
     * This method allows to create a payment profile for a customer using chargify_token.
     * @param {PaymentProfileInput} paymentProfileInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createPaymentProfile(e, r) {
      const s = await t.createPaymentProfile(e, r);
      return S(s, m, h, i);
    },
    /**
     * This method allows to create new subscription.
     * @param {SubscriptionInput} subscriptionInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createSubscription(e, r) {
      const s = await t.createSubscription(e, r);
      return S(s, m, h, i);
    },
    /**
     * This method allows to delete the Customer.
     * @param {number} id Chargify customer\&#39;s ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteCustomer(e, r) {
      const s = await t.deleteCustomer(e, r);
      return S(s, m, h, i);
    },
    /**
     * Deletes an unused payment profile. (Read more.)[https://developers.chargify.com/docs/api-docs/eaf0053209dfa-delete-unused-payment-profile]
     * @param {number} paymentProfileId Chargify payment profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deletePaymentProfile(e, r) {
      const s = await t.deletePaymentProfile(e, r);
      return S(s, m, h, i);
    },
    /**
     * This request will by default list all customers associated with your Site. [Read more](https://developers.chargify.com/docs/api-docs/3fb9201a18426-list-or-find-customers)
     * @param {string} q Search query parameter to retrieve an array of customers that matches the search query. Search by:- an email, Chargify ID, organisation, first or last name, reference value from your application.
     * @param {number} [page] Result records are organized in pages. By default, the first page of results is displayed. The page parameter specifies a page number of results to fetch. You can start navigating through the pages to consume the results. You do this by passing in a page parameter. Retrieve the next page by adding ?page&#x3D;2 to the query string. If there are no results to return, then an empty result set will be returned.
     * @param {number} [perPage] This parameter indicates how many records to fetch in each request. Default value is 50. The maximum allowed values is 200; any per_page value over 200 will be changed to 200.
     * @param {'created_at' | 'updated_at'} [dateField] The type of filter you would like to apply to your search
     * @param {'asc' | 'desc'} [direction] The sort direction of the returned invoices.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async findCustomers(e, r, s, a, o, n) {
      const c = await t.findCustomers(
        e,
        r,
        s,
        a,
        o,
        n
      );
      return S(c, m, h, i);
    },
    /**
     * This method allows to retrieve the Customer properties by Chargify-generated Customer ID.
     * @param {number} id Chargify customer\&#39;s ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCustomer(e, r) {
      const s = await t.getCustomer(e, r);
      return S(s, m, h, i);
    },
    /**
     * Use this method to return the customer object if you have the unique Reference ID (Your App) value handy. It will return a single match.
     * @param {string} reference Infura\&#39;s chargify customer reference. Value is Infura user\&#39;s Id &#x60;{user.id}&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCustomerByReference(e, r) {
      const s = await t.getCustomerByReference(e, r);
      return S(s, m, h, i);
    },
    /**
     * This method returns invoices for a specific customer. By default, invoices returned on the index will only include `totals`, not detailed breakdowns for `line_items`, `discounts`, `taxes`, `credits`, `payments`, `custom_fields`, or `refunds`. To include breakdowns, pass the specific field as a key in the query with a value set to `true`.
     * @param {string} customerIds Allows fetching invoices with matching customer id based on provided values.
     * @param {number} [page] Result records are organized in pages. By default, the first page of results is displayed. The page parameter specifies a page number of results to fetch. You can start navigating through the pages to consume the results. You do this by passing in a page parameter. Retrieve the next page by adding ?page&#x3D;2 to the query string. If there are no results to return, then an empty result set will be returned.
     * @param {number} [perPage] This parameter indicates how many records to fetch in each request. Default value is 20. The maximum allowed values is 200; any per_page value over 200 will be changed to 200.
     * @param {number} [subscriptionId] The subscription\&#39;s ID.
     * @param {'created_at' | 'due_date' | 'issue_date' | 'updated_at' | 'paid_date'} [dateField] The type of filter you would like to apply to your search
     * @param {boolean} [lineItems] Include line items data
     * @param {'asc' | 'desc'} [direction] The sort direction of the returned invoices.
     * @param {boolean} [credits] Include credits data
     * @param {boolean} [customFields] Include custom fields data
     * @param {boolean} [discounts] Include discounts data
     * @param {string} [endDate] The end date (format &#x60;YYYY-MM-DD&#x60;) with which to filter the date_field. Returns invoices with a timestamp up to and including 11:59:59PM in your site\&#39;s time zone on the date specified.
     * @param {string} [endDatetime] The end date and time (format &#x60;YYYY-MM-DD HH:MM:SS&#x60;) with which to filter the date_field. Returns invoices with a timestamp at or before exact time provided in query. You can specify timezone in query - otherwise your site\&#39;s time zone will be used. If provided, this parameter will be used instead of end_date. Allowed to be used only along with date_field set to created_at or updated_at.
     * @param {string} [number] Include custom fields data
     * @param {boolean} [payments] Include payments data
     * @param {string} [productIds] Allows fetching invoices with matching line items product ids based on provided values.
     * @param {boolean} [refunds] Include refunds data
     * @param {'status' | 'total_amount' | 'due_amount' | 'created_at' | 'updated_at' | 'issue_date' | 'due_date' | 'number'} [sort] Allows specification of the order of the returned list.
     * @param {string} [startDate] The start date (format &#x60;YYYY-MM-DD&#x60;) with which to filter the date_field. Returns invoices with a timestamp at or after midnight (&#x60;12:00:00 AM&#x60;) in your site\&#39;s time zone on the date specified.
     * @param {string} [startDatetime] The start date and time (format &#x60;YYYY-MM-DD HH:MM:SS&#x60;&#x60;) with which to filter the date_field. Returns invoices with a timestamp at or after exact time provided in query. You can specify timezone in query - otherwise your site\&#39;s time zone will be used. If provided, this parameter will be used instead of start_date. Allowed to be used only along with date_field set to created_at or updated_at.
     * @param {InvoiceStatus} [status] The current status of the invoice.
     * @param {string} [subscriptionGroupUid] The UID of the subscription group you want to fetch consolidated invoices for. This will return a paginated list of consolidated invoices for the specified group.
     * @param {boolean} [taxes] Include taxes data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCustomerInvoices(e, r, s, a, o, n, c, l, p, R, u, E, I, U, T, f, v, N, L, w, B, j, F) {
      const g = await t.getCustomerInvoices(
        e,
        r,
        s,
        a,
        o,
        n,
        c,
        l,
        p,
        R,
        u,
        E,
        I,
        U,
        T,
        f,
        v,
        N,
        L,
        w,
        B,
        j,
        F
      );
      return S(g, m, h, i);
    },
    /**
     * This method lists all subscriptions that belong to a customer.
     * @param {number} id Chargify customer\&#39;s ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCustomerSubscriptions(e, r) {
      const s = await t.getCustomerSubscriptions(e, r);
      return S(s, m, h, i);
    },
    /**
     * This method retrieves a Payment Profile identified by its unique ID.
     * @param {number} paymentProfileId Chargify payment profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPaymentProfile(e, r) {
      const s = await t.getPaymentProfile(e, r);
      return S(s, m, h, i);
    },
    /**
     * Use this endpoint to read current price points that are associated with a component
     * @param {ChargifyComponentIDInput} componentId
     * @param {boolean} [currencyPrices] Include an array of currency price data
     * @param {GetPricePointsByComponentIdFilterParameter} [filter]
     * @param {number} [page] Result records are organized in pages. By default, the first page of results is displayed. The page parameter specifies a page number of results to fetch. You can start navigating through the pages to consume the results. You do this by passing in a page parameter. Retrieve the next page by adding ?page&#x3D;2 to the query string. If there are no results to return, then an empty result set will be returned.
     * @param {number} [perPage] This parameter indicates how many records to fetch in each request. Default value is 20. The maximum allowed values is 200; any per_page value over 200 will be changed to 200.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPricePointsByComponentId(e, r, s, a, o, n) {
      const c = await t.getPricePointsByComponentId(
        e,
        r,
        s,
        a,
        o,
        n
      );
      return S(c, m, h, i);
    },
    /**
     * Use this endpoint to find a subscription by its reference.
     * @param {string} reference Subscription reference. Usually in this shape &#x60;infura_{user.id}&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSubscription(e, r) {
      const s = await t.getSubscription(e, r);
      return S(s, m, h, i);
    },
    /**
     * Use this endpoint to find a subscription by its reference.
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {'coupons'} include The coupon code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSubscriptionById(e, r, s) {
      const a = await t.getSubscriptionById(e, r, s);
      return S(a, m, h, i);
    },
    /**
     * This endpoint returns the 50 most recent Allocations of the specified component to a subscription, ordered by most recent first. [Read more](https://developers.chargify.com/docs/api-docs/f70716b0e80f1-list-allocations)
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {ChargifyComponentIDInput} componentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listComponentAllocations(e, r, s) {
      const a = await t.listComponentAllocations(
        e,
        r,
        s
      );
      return S(a, m, h, i);
    },
    /**
     * This method will return a list of components for a particular product family.
     * @param {number} productFamilyId The product family ID
     * @param {number} [page] Result records are organized in pages. By default, the first page of results is displayed. The page parameter specifies a page number of results to fetch. You can start navigating through the pages to consume the results. You do this by passing in a page parameter. Retrieve the next page by adding ?page&#x3D;2 to the query string. If there are no results to return, then an empty result set will be returned.
     * @param {number} [perPage] This parameter indicates how many records to fetch in each request. Default value is 20. The maximum allowed values is 200; any per_page value over 200 will be changed to 200.
     * @param {boolean} [includeArchived] Include archived items.
     * @param {ListComponentsByProductFamilyIdFilterParameter} [filter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listComponentsByProductFamilyId(e, r, s, a, o, n) {
      const c = await t.listComponentsByProductFamilyId(
        e,
        r,
        s,
        a,
        o,
        n
      );
      return S(c, m, h, i);
    },
    /**
     * This method will return all of the ACTIVE `payment_profiles` for one Customer within a site. If no payment profiles are found, this endpoint will return an empty array, not a 404.
     * @param {number} customerId Chargify customer ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listCustomerActivePaymentProfiles(e, r) {
      const s = await t.listCustomerActivePaymentProfiles(e, r);
      return S(s, m, h, i);
    },
    /**
     * This method allows to retrieve a list of Products belonging to a Site
     * @param {number} [page] Result records are organized in pages. By default, the first page of results is displayed. The page parameter specifies a page number of results to fetch. You can start navigating through the pages to consume the results. You do this by passing in a page parameter. Retrieve the next page by adding ?page&#x3D;2 to the query string. If there are no results to return, then an empty result set will be returned.
     * @param {number} [perPage] This parameter indicates how many records to fetch in each request. Default value is 20. The maximum allowed values is 200; any per_page value over 200 will be changed to 200.
     * @param {boolean} [includeArchived] Include archived products.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listProducts(e, r, s, a) {
      const o = await t.listProducts(e, r, s, a);
      return S(o, m, h, i);
    },
    /**
     * This method will return a list customer\'s subscriptions from a Site.
     * @param {ListSubscriptionsByCustomerReferenceMetadataParameter} metadata
     * @param {SubscriptionState} [state]
     * @param {'updated_at' | 'created_at'} [sort]
     * @param {number} [page] Result records are organized in pages. By default, the first page of results is displayed. The page parameter specifies a page number of results to fetch. You can start navigating through the pages to consume the results. You do this by passing in a page parameter. Retrieve the next page by adding ?page&#x3D;2 to the query string. If there are no results to return, then an empty result set will be returned.
     * @param {number} [perPage] This parameter indicates how many records to fetch in each request. Default value is 20. The maximum allowed values is 200; any per_page value over 200 will be changed to 200.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listSubscriptionsByCustomerReference(e, r, s, a, o, n) {
      const c = await t.listSubscriptionsByCustomerReference(
        e,
        r,
        s,
        a,
        o,
        n
      );
      return S(c, m, h, i);
    },
    /**
     * Subscriptions should be in the `active` or `trialing` state in order to be migrated. [Read more](https://developers.chargify.com/docs/api-docs/c6f96f0245a2d-migrate-subscription-product)
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {MigrateSubscriptionInput} migrateSubscriptionInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async migrateSubscription(e, r, s) {
      const a = await t.migrateSubscription(
        e,
        r,
        s
      );
      return S(a, m, h, i);
    },
    /**
     * Preview the creation of a new subscription without creating it.
     * @param {SubscriptionInput} subscriptionInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async previewSubscription(e, r) {
      const s = await t.previewSubscription(e, r);
      return S(s, m, h, i);
    },
    /**
     * Use this endpoint to remove a coupon from an existing subscription. [Read more](https://developers.chargify.com/docs/api-docs/4ba9e0490364e-remove-coupon-from-subscription)
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {string} couponCode The coupon code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeCoupon(e, r, s) {
      const a = await t.removeCoupon(e, r, s);
      return S(a, m, h, i);
    },
    /**
     * Use this endpoint to retry a canceled Chargify subscription. [Read more](https://developers.chargify.com/docs/api-docs/4ba9e0490364e-retry-subscription)
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async retrySubscription(e, r) {
      const s = await t.retrySubscription(e, r);
      return S(s, m, h, i);
    },
    /**
     * This method allows to update the Customer.
     * @param {number} id Chargify customer\&#39;s ID
     * @param {CustomerInput} customerInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateCustomer(e, r, s) {
      const a = await t.updateCustomer(e, r, s);
      return S(a, m, h, i);
    },
    /**
     * This request will update any metadata belonging to a particular resource (ie. subscription, customer) that is specified.
     * @param {'customers' | 'subscriptions'} resourceType Chargify resource (ie. subscription, customer)
     * @param {number} resourceId Chargify payment profile ID
     * @param {MetadataInput} metadataInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateMetadata(e, r, s, a) {
      const o = await t.updateMetadata(
        e,
        r,
        s,
        a
      );
      return S(o, m, h, i);
    },
    /**
     * (Read more.)[https://developers.chargify.com/docs/api-docs/6f6e08831dee5-update-payment-profile]
     * @param {number} paymentProfileId Chargify payment profile ID
     * @param {UpdateBillingInfoInput} updateBillingInfoInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updatePaymentProfile(e, r, s) {
      const a = await t.updatePaymentProfile(
        e,
        r,
        s
      );
      return S(a, m, h, i);
    },
    /**
     * The subscription endpoint allows you to instantly update one or many attributes about a subscription in a single call.
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {UpdateSubscriptionInput} updateSubscriptionInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateSubscription(e, r, s) {
      const a = await t.updateSubscription(
        e,
        r,
        s
      );
      return S(a, m, h, i);
    },
    /**
     * This will change the default payment profile on the subscription to the existing payment profile with the id specified. You must elect to change the existing payment profile to a new payment profile ID in order to receive a satisfactory response from this endpoint. [Read more](https://developers.chargify.com/docs/api-docs/55c36d1e77566-change-subscription-default-payment-profile)
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {number} paymentProfileId The Chargify ID of the payment profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateSubscriptionPaymentProfile(e, r, s) {
      const a = await t.updateSubscriptionPaymentProfile(
        e,
        r,
        s
      );
      return S(a, m, h, i);
    },
    /**
     * This method is useful for validating coupon codes that are entered by a customer.
     * @param {string} code The code of the coupon
     * @param {string} [productFamilyId] The Chargify id or handle of the product family to which the coupon belongs. Product family handle can be used in the product_family_id field, all that\&#39;s needed is a \&quot;handle:\&quot; prefix. For example, if your product_family_id\&#39;s handle is \&quot;infura-core\&quot;, the value in product_family_id would be \&quot;handle:infura-core\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async validateCoupon(e, r, s) {
      const a = await t.validateCoupon(e, r, s);
      return S(a, m, h, i);
    }
  };
}, Le = function(i, t, e) {
  const r = P(i);
  return {
    /**
     * An existing subscription can accommodate multiple discounts/coupon codes. This is only applicable if each coupon is stackable. [Read more](https://developers.chargify.com/docs/api-docs/fea46972c2a88-add-coupons-to-subscription)
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {SubcriptionCouponInput} subcriptionCouponInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addCoupon(s, a, o) {
      return r.addCoupon(s, a, o).then((n) => n(e, t));
    },
    /**
     * Creates multiple allocations, setting the current allocated quantity for each of the components and recording a memo. [Read more](https://developers.chargify.com/docs/api-docs/7d5adfebf33f3-allocate-components)
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {MultipleComponentAllocationInput} multipleComponentAllocationInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allocateComponents(s, a, o) {
      return r.allocateComponents(s, a, o).then((n) => n(e, t));
    },
    /**
     * This action causes the cancellation of the Subscription. This means, the method sets the Subscription state to \"canceled\".
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {CancelSubscriptionInput} [cancelSubscriptionInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelSubscription(s, a, o) {
      return r.cancelSubscription(s, a, o).then((n) => n(e, t));
    },
    /**
     * This method allows to create new customers
     * @param {CustomerInput} customerInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCustomer(s, a) {
      return r.createCustomer(s, a).then((o) => o(e, t));
    },
    /**
     * This method allows to create a payment profile for a customer using chargify_token.
     * @param {PaymentProfileInput} paymentProfileInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPaymentProfile(s, a) {
      return r.createPaymentProfile(s, a).then((o) => o(e, t));
    },
    /**
     * This method allows to create new subscription.
     * @param {SubscriptionInput} subscriptionInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSubscription(s, a) {
      return r.createSubscription(s, a).then((o) => o(e, t));
    },
    /**
     * This method allows to delete the Customer.
     * @param {number} id Chargify customer\&#39;s ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCustomer(s, a) {
      return r.deleteCustomer(s, a).then((o) => o(e, t));
    },
    /**
     * Deletes an unused payment profile. (Read more.)[https://developers.chargify.com/docs/api-docs/eaf0053209dfa-delete-unused-payment-profile]
     * @param {number} paymentProfileId Chargify payment profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePaymentProfile(s, a) {
      return r.deletePaymentProfile(s, a).then((o) => o(e, t));
    },
    /**
     * This request will by default list all customers associated with your Site. [Read more](https://developers.chargify.com/docs/api-docs/3fb9201a18426-list-or-find-customers)
     * @param {string} q Search query parameter to retrieve an array of customers that matches the search query. Search by:- an email, Chargify ID, organisation, first or last name, reference value from your application.
     * @param {number} [page] Result records are organized in pages. By default, the first page of results is displayed. The page parameter specifies a page number of results to fetch. You can start navigating through the pages to consume the results. You do this by passing in a page parameter. Retrieve the next page by adding ?page&#x3D;2 to the query string. If there are no results to return, then an empty result set will be returned.
     * @param {number} [perPage] This parameter indicates how many records to fetch in each request. Default value is 50. The maximum allowed values is 200; any per_page value over 200 will be changed to 200.
     * @param {'created_at' | 'updated_at'} [dateField] The type of filter you would like to apply to your search
     * @param {'asc' | 'desc'} [direction] The sort direction of the returned invoices.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findCustomers(s, a, o, n, c, l) {
      return r.findCustomers(s, a, o, n, c, l).then((p) => p(e, t));
    },
    /**
     * This method allows to retrieve the Customer properties by Chargify-generated Customer ID.
     * @param {number} id Chargify customer\&#39;s ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomer(s, a) {
      return r.getCustomer(s, a).then((o) => o(e, t));
    },
    /**
     * Use this method to return the customer object if you have the unique Reference ID (Your App) value handy. It will return a single match.
     * @param {string} reference Infura\&#39;s chargify customer reference. Value is Infura user\&#39;s Id &#x60;{user.id}&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomerByReference(s, a) {
      return r.getCustomerByReference(s, a).then((o) => o(e, t));
    },
    /**
     * This method returns invoices for a specific customer. By default, invoices returned on the index will only include `totals`, not detailed breakdowns for `line_items`, `discounts`, `taxes`, `credits`, `payments`, `custom_fields`, or `refunds`. To include breakdowns, pass the specific field as a key in the query with a value set to `true`.
     * @param {string} customerIds Allows fetching invoices with matching customer id based on provided values.
     * @param {number} [page] Result records are organized in pages. By default, the first page of results is displayed. The page parameter specifies a page number of results to fetch. You can start navigating through the pages to consume the results. You do this by passing in a page parameter. Retrieve the next page by adding ?page&#x3D;2 to the query string. If there are no results to return, then an empty result set will be returned.
     * @param {number} [perPage] This parameter indicates how many records to fetch in each request. Default value is 20. The maximum allowed values is 200; any per_page value over 200 will be changed to 200.
     * @param {number} [subscriptionId] The subscription\&#39;s ID.
     * @param {'created_at' | 'due_date' | 'issue_date' | 'updated_at' | 'paid_date'} [dateField] The type of filter you would like to apply to your search
     * @param {boolean} [lineItems] Include line items data
     * @param {'asc' | 'desc'} [direction] The sort direction of the returned invoices.
     * @param {boolean} [credits] Include credits data
     * @param {boolean} [customFields] Include custom fields data
     * @param {boolean} [discounts] Include discounts data
     * @param {string} [endDate] The end date (format &#x60;YYYY-MM-DD&#x60;) with which to filter the date_field. Returns invoices with a timestamp up to and including 11:59:59PM in your site\&#39;s time zone on the date specified.
     * @param {string} [endDatetime] The end date and time (format &#x60;YYYY-MM-DD HH:MM:SS&#x60;) with which to filter the date_field. Returns invoices with a timestamp at or before exact time provided in query. You can specify timezone in query - otherwise your site\&#39;s time zone will be used. If provided, this parameter will be used instead of end_date. Allowed to be used only along with date_field set to created_at or updated_at.
     * @param {string} [number] Include custom fields data
     * @param {boolean} [payments] Include payments data
     * @param {string} [productIds] Allows fetching invoices with matching line items product ids based on provided values.
     * @param {boolean} [refunds] Include refunds data
     * @param {'status' | 'total_amount' | 'due_amount' | 'created_at' | 'updated_at' | 'issue_date' | 'due_date' | 'number'} [sort] Allows specification of the order of the returned list.
     * @param {string} [startDate] The start date (format &#x60;YYYY-MM-DD&#x60;) with which to filter the date_field. Returns invoices with a timestamp at or after midnight (&#x60;12:00:00 AM&#x60;) in your site\&#39;s time zone on the date specified.
     * @param {string} [startDatetime] The start date and time (format &#x60;YYYY-MM-DD HH:MM:SS&#x60;&#x60;) with which to filter the date_field. Returns invoices with a timestamp at or after exact time provided in query. You can specify timezone in query - otherwise your site\&#39;s time zone will be used. If provided, this parameter will be used instead of start_date. Allowed to be used only along with date_field set to created_at or updated_at.
     * @param {InvoiceStatus} [status] The current status of the invoice.
     * @param {string} [subscriptionGroupUid] The UID of the subscription group you want to fetch consolidated invoices for. This will return a paginated list of consolidated invoices for the specified group.
     * @param {boolean} [taxes] Include taxes data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomerInvoices(s, a, o, n, c, l, p, R, u, E, I, U, T, f, v, N, L, w, B, j, F, g, D) {
      return r.getCustomerInvoices(
        s,
        a,
        o,
        n,
        c,
        l,
        p,
        R,
        u,
        E,
        I,
        U,
        T,
        f,
        v,
        N,
        L,
        w,
        B,
        j,
        F,
        g,
        D
      ).then((M) => M(e, t));
    },
    /**
     * This method lists all subscriptions that belong to a customer.
     * @param {number} id Chargify customer\&#39;s ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomerSubscriptions(s, a) {
      return r.getCustomerSubscriptions(s, a).then((o) => o(e, t));
    },
    /**
     * This method retrieves a Payment Profile identified by its unique ID.
     * @param {number} paymentProfileId Chargify payment profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentProfile(s, a) {
      return r.getPaymentProfile(s, a).then((o) => o(e, t));
    },
    /**
     * Use this endpoint to read current price points that are associated with a component
     * @param {ChargifyComponentIDInput} componentId
     * @param {boolean} [currencyPrices] Include an array of currency price data
     * @param {GetPricePointsByComponentIdFilterParameter} [filter]
     * @param {number} [page] Result records are organized in pages. By default, the first page of results is displayed. The page parameter specifies a page number of results to fetch. You can start navigating through the pages to consume the results. You do this by passing in a page parameter. Retrieve the next page by adding ?page&#x3D;2 to the query string. If there are no results to return, then an empty result set will be returned.
     * @param {number} [perPage] This parameter indicates how many records to fetch in each request. Default value is 20. The maximum allowed values is 200; any per_page value over 200 will be changed to 200.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPricePointsByComponentId(s, a, o, n, c, l) {
      return r.getPricePointsByComponentId(s, a, o, n, c, l).then((p) => p(e, t));
    },
    /**
     * Use this endpoint to find a subscription by its reference.
     * @param {string} reference Subscription reference. Usually in this shape &#x60;infura_{user.id}&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscription(s, a) {
      return r.getSubscription(s, a).then((o) => o(e, t));
    },
    /**
     * Use this endpoint to find a subscription by its reference.
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {'coupons'} include The coupon code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionById(s, a, o) {
      return r.getSubscriptionById(s, a, o).then((n) => n(e, t));
    },
    /**
     * This endpoint returns the 50 most recent Allocations of the specified component to a subscription, ordered by most recent first. [Read more](https://developers.chargify.com/docs/api-docs/f70716b0e80f1-list-allocations)
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {ChargifyComponentIDInput} componentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listComponentAllocations(s, a, o) {
      return r.listComponentAllocations(s, a, o).then((n) => n(e, t));
    },
    /**
     * This method will return a list of components for a particular product family.
     * @param {number} productFamilyId The product family ID
     * @param {number} [page] Result records are organized in pages. By default, the first page of results is displayed. The page parameter specifies a page number of results to fetch. You can start navigating through the pages to consume the results. You do this by passing in a page parameter. Retrieve the next page by adding ?page&#x3D;2 to the query string. If there are no results to return, then an empty result set will be returned.
     * @param {number} [perPage] This parameter indicates how many records to fetch in each request. Default value is 20. The maximum allowed values is 200; any per_page value over 200 will be changed to 200.
     * @param {boolean} [includeArchived] Include archived items.
     * @param {ListComponentsByProductFamilyIdFilterParameter} [filter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listComponentsByProductFamilyId(s, a, o, n, c, l) {
      return r.listComponentsByProductFamilyId(s, a, o, n, c, l).then((p) => p(e, t));
    },
    /**
     * This method will return all of the ACTIVE `payment_profiles` for one Customer within a site. If no payment profiles are found, this endpoint will return an empty array, not a 404.
     * @param {number} customerId Chargify customer ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCustomerActivePaymentProfiles(s, a) {
      return r.listCustomerActivePaymentProfiles(s, a).then((o) => o(e, t));
    },
    /**
     * This method allows to retrieve a list of Products belonging to a Site
     * @param {number} [page] Result records are organized in pages. By default, the first page of results is displayed. The page parameter specifies a page number of results to fetch. You can start navigating through the pages to consume the results. You do this by passing in a page parameter. Retrieve the next page by adding ?page&#x3D;2 to the query string. If there are no results to return, then an empty result set will be returned.
     * @param {number} [perPage] This parameter indicates how many records to fetch in each request. Default value is 20. The maximum allowed values is 200; any per_page value over 200 will be changed to 200.
     * @param {boolean} [includeArchived] Include archived products.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listProducts(s, a, o, n) {
      return r.listProducts(s, a, o, n).then((c) => c(e, t));
    },
    /**
     * This method will return a list customer\'s subscriptions from a Site.
     * @param {ListSubscriptionsByCustomerReferenceMetadataParameter} metadata
     * @param {SubscriptionState} [state]
     * @param {'updated_at' | 'created_at'} [sort]
     * @param {number} [page] Result records are organized in pages. By default, the first page of results is displayed. The page parameter specifies a page number of results to fetch. You can start navigating through the pages to consume the results. You do this by passing in a page parameter. Retrieve the next page by adding ?page&#x3D;2 to the query string. If there are no results to return, then an empty result set will be returned.
     * @param {number} [perPage] This parameter indicates how many records to fetch in each request. Default value is 20. The maximum allowed values is 200; any per_page value over 200 will be changed to 200.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listSubscriptionsByCustomerReference(s, a, o, n, c, l) {
      return r.listSubscriptionsByCustomerReference(s, a, o, n, c, l).then((p) => p(e, t));
    },
    /**
     * Subscriptions should be in the `active` or `trialing` state in order to be migrated. [Read more](https://developers.chargify.com/docs/api-docs/c6f96f0245a2d-migrate-subscription-product)
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {MigrateSubscriptionInput} migrateSubscriptionInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    migrateSubscription(s, a, o) {
      return r.migrateSubscription(s, a, o).then((n) => n(e, t));
    },
    /**
     * Preview the creation of a new subscription without creating it.
     * @param {SubscriptionInput} subscriptionInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    previewSubscription(s, a) {
      return r.previewSubscription(s, a).then((o) => o(e, t));
    },
    /**
     * Use this endpoint to remove a coupon from an existing subscription. [Read more](https://developers.chargify.com/docs/api-docs/4ba9e0490364e-remove-coupon-from-subscription)
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {string} couponCode The coupon code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeCoupon(s, a, o) {
      return r.removeCoupon(s, a, o).then((n) => n(e, t));
    },
    /**
     * Use this endpoint to retry a canceled Chargify subscription. [Read more](https://developers.chargify.com/docs/api-docs/4ba9e0490364e-retry-subscription)
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retrySubscription(s, a) {
      return r.retrySubscription(s, a).then((o) => o(e, t));
    },
    /**
     * This method allows to update the Customer.
     * @param {number} id Chargify customer\&#39;s ID
     * @param {CustomerInput} customerInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCustomer(s, a, o) {
      return r.updateCustomer(s, a, o).then((n) => n(e, t));
    },
    /**
     * This request will update any metadata belonging to a particular resource (ie. subscription, customer) that is specified.
     * @param {'customers' | 'subscriptions'} resourceType Chargify resource (ie. subscription, customer)
     * @param {number} resourceId Chargify payment profile ID
     * @param {MetadataInput} metadataInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateMetadata(s, a, o, n) {
      return r.updateMetadata(s, a, o, n).then((c) => c(e, t));
    },
    /**
     * (Read more.)[https://developers.chargify.com/docs/api-docs/6f6e08831dee5-update-payment-profile]
     * @param {number} paymentProfileId Chargify payment profile ID
     * @param {UpdateBillingInfoInput} updateBillingInfoInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePaymentProfile(s, a, o) {
      return r.updatePaymentProfile(s, a, o).then((n) => n(e, t));
    },
    /**
     * The subscription endpoint allows you to instantly update one or many attributes about a subscription in a single call.
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {UpdateSubscriptionInput} updateSubscriptionInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSubscription(s, a, o) {
      return r.updateSubscription(s, a, o).then((n) => n(e, t));
    },
    /**
     * This will change the default payment profile on the subscription to the existing payment profile with the id specified. You must elect to change the existing payment profile to a new payment profile ID in order to receive a satisfactory response from this endpoint. [Read more](https://developers.chargify.com/docs/api-docs/55c36d1e77566-change-subscription-default-payment-profile)
     * @param {number} subscriptionId The Chargify subscription ID
     * @param {number} paymentProfileId The Chargify ID of the payment profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSubscriptionPaymentProfile(s, a, o) {
      return r.updateSubscriptionPaymentProfile(s, a, o).then((n) => n(e, t));
    },
    /**
     * This method is useful for validating coupon codes that are entered by a customer.
     * @param {string} code The code of the coupon
     * @param {string} [productFamilyId] The Chargify id or handle of the product family to which the coupon belongs. Product family handle can be used in the product_family_id field, all that\&#39;s needed is a \&quot;handle:\&quot; prefix. For example, if your product_family_id\&#39;s handle is \&quot;infura-core\&quot;, the value in product_family_id would be \&quot;handle:infura-core\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    validateCoupon(s, a, o) {
      return r.validateCoupon(s, a, o).then((n) => n(e, t));
    }
  };
};
class we extends G {
  /**
   * An existing subscription can accommodate multiple discounts/coupon codes. This is only applicable if each coupon is stackable. [Read more](https://developers.chargify.com/docs/api-docs/fea46972c2a88-add-coupons-to-subscription)
   * @param {number} subscriptionId The Chargify subscription ID
   * @param {SubcriptionCouponInput} subcriptionCouponInput
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  addCoupon(t, e, r) {
    return P(this.configuration).addCoupon(t, e, r).then((s) => s(this.axios, this.basePath));
  }
  /**
   * Creates multiple allocations, setting the current allocated quantity for each of the components and recording a memo. [Read more](https://developers.chargify.com/docs/api-docs/7d5adfebf33f3-allocate-components)
   * @param {number} subscriptionId The Chargify subscription ID
   * @param {MultipleComponentAllocationInput} multipleComponentAllocationInput
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  allocateComponents(t, e, r) {
    return P(this.configuration).allocateComponents(t, e, r).then((s) => s(this.axios, this.basePath));
  }
  /**
   * This action causes the cancellation of the Subscription. This means, the method sets the Subscription state to \"canceled\".
   * @param {number} subscriptionId The Chargify subscription ID
   * @param {CancelSubscriptionInput} [cancelSubscriptionInput]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  cancelSubscription(t, e, r) {
    return P(this.configuration).cancelSubscription(t, e, r).then((s) => s(this.axios, this.basePath));
  }
  /**
   * This method allows to create new customers
   * @param {CustomerInput} customerInput
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  createCustomer(t, e) {
    return P(this.configuration).createCustomer(t, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * This method allows to create a payment profile for a customer using chargify_token.
   * @param {PaymentProfileInput} paymentProfileInput
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  createPaymentProfile(t, e) {
    return P(this.configuration).createPaymentProfile(t, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * This method allows to create new subscription.
   * @param {SubscriptionInput} subscriptionInput
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  createSubscription(t, e) {
    return P(this.configuration).createSubscription(t, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * This method allows to delete the Customer.
   * @param {number} id Chargify customer\&#39;s ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  deleteCustomer(t, e) {
    return P(this.configuration).deleteCustomer(t, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Deletes an unused payment profile. (Read more.)[https://developers.chargify.com/docs/api-docs/eaf0053209dfa-delete-unused-payment-profile]
   * @param {number} paymentProfileId Chargify payment profile ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  deletePaymentProfile(t, e) {
    return P(this.configuration).deletePaymentProfile(t, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * This request will by default list all customers associated with your Site. [Read more](https://developers.chargify.com/docs/api-docs/3fb9201a18426-list-or-find-customers)
   * @param {string} q Search query parameter to retrieve an array of customers that matches the search query. Search by:- an email, Chargify ID, organisation, first or last name, reference value from your application.
   * @param {number} [page] Result records are organized in pages. By default, the first page of results is displayed. The page parameter specifies a page number of results to fetch. You can start navigating through the pages to consume the results. You do this by passing in a page parameter. Retrieve the next page by adding ?page&#x3D;2 to the query string. If there are no results to return, then an empty result set will be returned.
   * @param {number} [perPage] This parameter indicates how many records to fetch in each request. Default value is 50. The maximum allowed values is 200; any per_page value over 200 will be changed to 200.
   * @param {'created_at' | 'updated_at'} [dateField] The type of filter you would like to apply to your search
   * @param {'asc' | 'desc'} [direction] The sort direction of the returned invoices.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  findCustomers(t, e, r, s, a, o) {
    return P(this.configuration).findCustomers(t, e, r, s, a, o).then((n) => n(this.axios, this.basePath));
  }
  /**
   * This method allows to retrieve the Customer properties by Chargify-generated Customer ID.
   * @param {number} id Chargify customer\&#39;s ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getCustomer(t, e) {
    return P(this.configuration).getCustomer(t, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Use this method to return the customer object if you have the unique Reference ID (Your App) value handy. It will return a single match.
   * @param {string} reference Infura\&#39;s chargify customer reference. Value is Infura user\&#39;s Id &#x60;{user.id}&#x60;
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getCustomerByReference(t, e) {
    return P(this.configuration).getCustomerByReference(t, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * This method returns invoices for a specific customer. By default, invoices returned on the index will only include `totals`, not detailed breakdowns for `line_items`, `discounts`, `taxes`, `credits`, `payments`, `custom_fields`, or `refunds`. To include breakdowns, pass the specific field as a key in the query with a value set to `true`.
   * @param {string} customerIds Allows fetching invoices with matching customer id based on provided values.
   * @param {number} [page] Result records are organized in pages. By default, the first page of results is displayed. The page parameter specifies a page number of results to fetch. You can start navigating through the pages to consume the results. You do this by passing in a page parameter. Retrieve the next page by adding ?page&#x3D;2 to the query string. If there are no results to return, then an empty result set will be returned.
   * @param {number} [perPage] This parameter indicates how many records to fetch in each request. Default value is 20. The maximum allowed values is 200; any per_page value over 200 will be changed to 200.
   * @param {number} [subscriptionId] The subscription\&#39;s ID.
   * @param {'created_at' | 'due_date' | 'issue_date' | 'updated_at' | 'paid_date'} [dateField] The type of filter you would like to apply to your search
   * @param {boolean} [lineItems] Include line items data
   * @param {'asc' | 'desc'} [direction] The sort direction of the returned invoices.
   * @param {boolean} [credits] Include credits data
   * @param {boolean} [customFields] Include custom fields data
   * @param {boolean} [discounts] Include discounts data
   * @param {string} [endDate] The end date (format &#x60;YYYY-MM-DD&#x60;) with which to filter the date_field. Returns invoices with a timestamp up to and including 11:59:59PM in your site\&#39;s time zone on the date specified.
   * @param {string} [endDatetime] The end date and time (format &#x60;YYYY-MM-DD HH:MM:SS&#x60;) with which to filter the date_field. Returns invoices with a timestamp at or before exact time provided in query. You can specify timezone in query - otherwise your site\&#39;s time zone will be used. If provided, this parameter will be used instead of end_date. Allowed to be used only along with date_field set to created_at or updated_at.
   * @param {string} [number] Include custom fields data
   * @param {boolean} [payments] Include payments data
   * @param {string} [productIds] Allows fetching invoices with matching line items product ids based on provided values.
   * @param {boolean} [refunds] Include refunds data
   * @param {'status' | 'total_amount' | 'due_amount' | 'created_at' | 'updated_at' | 'issue_date' | 'due_date' | 'number'} [sort] Allows specification of the order of the returned list.
   * @param {string} [startDate] The start date (format &#x60;YYYY-MM-DD&#x60;) with which to filter the date_field. Returns invoices with a timestamp at or after midnight (&#x60;12:00:00 AM&#x60;) in your site\&#39;s time zone on the date specified.
   * @param {string} [startDatetime] The start date and time (format &#x60;YYYY-MM-DD HH:MM:SS&#x60;&#x60;) with which to filter the date_field. Returns invoices with a timestamp at or after exact time provided in query. You can specify timezone in query - otherwise your site\&#39;s time zone will be used. If provided, this parameter will be used instead of start_date. Allowed to be used only along with date_field set to created_at or updated_at.
   * @param {InvoiceStatus} [status] The current status of the invoice.
   * @param {string} [subscriptionGroupUid] The UID of the subscription group you want to fetch consolidated invoices for. This will return a paginated list of consolidated invoices for the specified group.
   * @param {boolean} [taxes] Include taxes data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getCustomerInvoices(t, e, r, s, a, o, n, c, l, p, R, u, E, I, U, T, f, v, N, L, w, B, j) {
    return P(this.configuration).getCustomerInvoices(
      t,
      e,
      r,
      s,
      a,
      o,
      n,
      c,
      l,
      p,
      R,
      u,
      E,
      I,
      U,
      T,
      f,
      v,
      N,
      L,
      w,
      B,
      j
    ).then((F) => F(this.axios, this.basePath));
  }
  /**
   * This method lists all subscriptions that belong to a customer.
   * @param {number} id Chargify customer\&#39;s ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getCustomerSubscriptions(t, e) {
    return P(this.configuration).getCustomerSubscriptions(t, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * This method retrieves a Payment Profile identified by its unique ID.
   * @param {number} paymentProfileId Chargify payment profile ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getPaymentProfile(t, e) {
    return P(this.configuration).getPaymentProfile(t, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Use this endpoint to read current price points that are associated with a component
   * @param {ChargifyComponentIDInput} componentId
   * @param {boolean} [currencyPrices] Include an array of currency price data
   * @param {GetPricePointsByComponentIdFilterParameter} [filter]
   * @param {number} [page] Result records are organized in pages. By default, the first page of results is displayed. The page parameter specifies a page number of results to fetch. You can start navigating through the pages to consume the results. You do this by passing in a page parameter. Retrieve the next page by adding ?page&#x3D;2 to the query string. If there are no results to return, then an empty result set will be returned.
   * @param {number} [perPage] This parameter indicates how many records to fetch in each request. Default value is 20. The maximum allowed values is 200; any per_page value over 200 will be changed to 200.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getPricePointsByComponentId(t, e, r, s, a, o) {
    return P(this.configuration).getPricePointsByComponentId(t, e, r, s, a, o).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Use this endpoint to find a subscription by its reference.
   * @param {string} reference Subscription reference. Usually in this shape &#x60;infura_{user.id}&#x60;
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getSubscription(t, e) {
    return P(this.configuration).getSubscription(t, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Use this endpoint to find a subscription by its reference.
   * @param {number} subscriptionId The Chargify subscription ID
   * @param {'coupons'} include The coupon code
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getSubscriptionById(t, e, r) {
    return P(this.configuration).getSubscriptionById(t, e, r).then((s) => s(this.axios, this.basePath));
  }
  /**
   * This endpoint returns the 50 most recent Allocations of the specified component to a subscription, ordered by most recent first. [Read more](https://developers.chargify.com/docs/api-docs/f70716b0e80f1-list-allocations)
   * @param {number} subscriptionId The Chargify subscription ID
   * @param {ChargifyComponentIDInput} componentId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  listComponentAllocations(t, e, r) {
    return P(this.configuration).listComponentAllocations(t, e, r).then((s) => s(this.axios, this.basePath));
  }
  /**
   * This method will return a list of components for a particular product family.
   * @param {number} productFamilyId The product family ID
   * @param {number} [page] Result records are organized in pages. By default, the first page of results is displayed. The page parameter specifies a page number of results to fetch. You can start navigating through the pages to consume the results. You do this by passing in a page parameter. Retrieve the next page by adding ?page&#x3D;2 to the query string. If there are no results to return, then an empty result set will be returned.
   * @param {number} [perPage] This parameter indicates how many records to fetch in each request. Default value is 20. The maximum allowed values is 200; any per_page value over 200 will be changed to 200.
   * @param {boolean} [includeArchived] Include archived items.
   * @param {ListComponentsByProductFamilyIdFilterParameter} [filter]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  listComponentsByProductFamilyId(t, e, r, s, a, o) {
    return P(this.configuration).listComponentsByProductFamilyId(t, e, r, s, a, o).then((n) => n(this.axios, this.basePath));
  }
  /**
   * This method will return all of the ACTIVE `payment_profiles` for one Customer within a site. If no payment profiles are found, this endpoint will return an empty array, not a 404.
   * @param {number} customerId Chargify customer ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  listCustomerActivePaymentProfiles(t, e) {
    return P(this.configuration).listCustomerActivePaymentProfiles(t, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * This method allows to retrieve a list of Products belonging to a Site
   * @param {number} [page] Result records are organized in pages. By default, the first page of results is displayed. The page parameter specifies a page number of results to fetch. You can start navigating through the pages to consume the results. You do this by passing in a page parameter. Retrieve the next page by adding ?page&#x3D;2 to the query string. If there are no results to return, then an empty result set will be returned.
   * @param {number} [perPage] This parameter indicates how many records to fetch in each request. Default value is 20. The maximum allowed values is 200; any per_page value over 200 will be changed to 200.
   * @param {boolean} [includeArchived] Include archived products.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  listProducts(t, e, r, s) {
    return P(this.configuration).listProducts(t, e, r, s).then((a) => a(this.axios, this.basePath));
  }
  /**
   * This method will return a list customer\'s subscriptions from a Site.
   * @param {ListSubscriptionsByCustomerReferenceMetadataParameter} metadata
   * @param {SubscriptionState} [state]
   * @param {'updated_at' | 'created_at'} [sort]
   * @param {number} [page] Result records are organized in pages. By default, the first page of results is displayed. The page parameter specifies a page number of results to fetch. You can start navigating through the pages to consume the results. You do this by passing in a page parameter. Retrieve the next page by adding ?page&#x3D;2 to the query string. If there are no results to return, then an empty result set will be returned.
   * @param {number} [perPage] This parameter indicates how many records to fetch in each request. Default value is 20. The maximum allowed values is 200; any per_page value over 200 will be changed to 200.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  listSubscriptionsByCustomerReference(t, e, r, s, a, o) {
    return P(this.configuration).listSubscriptionsByCustomerReference(t, e, r, s, a, o).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Subscriptions should be in the `active` or `trialing` state in order to be migrated. [Read more](https://developers.chargify.com/docs/api-docs/c6f96f0245a2d-migrate-subscription-product)
   * @param {number} subscriptionId The Chargify subscription ID
   * @param {MigrateSubscriptionInput} migrateSubscriptionInput
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  migrateSubscription(t, e, r) {
    return P(this.configuration).migrateSubscription(t, e, r).then((s) => s(this.axios, this.basePath));
  }
  /**
   * Preview the creation of a new subscription without creating it.
   * @param {SubscriptionInput} subscriptionInput
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  previewSubscription(t, e) {
    return P(this.configuration).previewSubscription(t, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Use this endpoint to remove a coupon from an existing subscription. [Read more](https://developers.chargify.com/docs/api-docs/4ba9e0490364e-remove-coupon-from-subscription)
   * @param {number} subscriptionId The Chargify subscription ID
   * @param {string} couponCode The coupon code
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  removeCoupon(t, e, r) {
    return P(this.configuration).removeCoupon(t, e, r).then((s) => s(this.axios, this.basePath));
  }
  /**
   * Use this endpoint to retry a canceled Chargify subscription. [Read more](https://developers.chargify.com/docs/api-docs/4ba9e0490364e-retry-subscription)
   * @param {number} subscriptionId The Chargify subscription ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  retrySubscription(t, e) {
    return P(this.configuration).retrySubscription(t, e).then((r) => r(this.axios, this.basePath));
  }
  /**
   * This method allows to update the Customer.
   * @param {number} id Chargify customer\&#39;s ID
   * @param {CustomerInput} customerInput
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  updateCustomer(t, e, r) {
    return P(this.configuration).updateCustomer(t, e, r).then((s) => s(this.axios, this.basePath));
  }
  /**
   * This request will update any metadata belonging to a particular resource (ie. subscription, customer) that is specified.
   * @param {'customers' | 'subscriptions'} resourceType Chargify resource (ie. subscription, customer)
   * @param {number} resourceId Chargify payment profile ID
   * @param {MetadataInput} metadataInput
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  updateMetadata(t, e, r, s) {
    return P(this.configuration).updateMetadata(t, e, r, s).then((a) => a(this.axios, this.basePath));
  }
  /**
   * (Read more.)[https://developers.chargify.com/docs/api-docs/6f6e08831dee5-update-payment-profile]
   * @param {number} paymentProfileId Chargify payment profile ID
   * @param {UpdateBillingInfoInput} updateBillingInfoInput
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  updatePaymentProfile(t, e, r) {
    return P(this.configuration).updatePaymentProfile(t, e, r).then((s) => s(this.axios, this.basePath));
  }
  /**
   * The subscription endpoint allows you to instantly update one or many attributes about a subscription in a single call.
   * @param {number} subscriptionId The Chargify subscription ID
   * @param {UpdateSubscriptionInput} updateSubscriptionInput
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  updateSubscription(t, e, r) {
    return P(this.configuration).updateSubscription(t, e, r).then((s) => s(this.axios, this.basePath));
  }
  /**
   * This will change the default payment profile on the subscription to the existing payment profile with the id specified. You must elect to change the existing payment profile to a new payment profile ID in order to receive a satisfactory response from this endpoint. [Read more](https://developers.chargify.com/docs/api-docs/55c36d1e77566-change-subscription-default-payment-profile)
   * @param {number} subscriptionId The Chargify subscription ID
   * @param {number} paymentProfileId The Chargify ID of the payment profile
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  updateSubscriptionPaymentProfile(t, e, r) {
    return P(this.configuration).updateSubscriptionPaymentProfile(t, e, r).then((s) => s(this.axios, this.basePath));
  }
  /**
   * This method is useful for validating coupon codes that are entered by a customer.
   * @param {string} code The code of the coupon
   * @param {string} [productFamilyId] The Chargify id or handle of the product family to which the coupon belongs. Product family handle can be used in the product_family_id field, all that\&#39;s needed is a \&quot;handle:\&quot; prefix. For example, if your product_family_id\&#39;s handle is \&quot;infura-core\&quot;, the value in product_family_id would be \&quot;handle:infura-core\&quot;.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  validateCoupon(t, e, r) {
    return P(this.configuration).validateCoupon(t, e, r).then((s) => s(this.axios, this.basePath));
  }
}
class Be {
  constructor(t = {}) {
    /**
     * parameter for apiKey security
     * @param name security name
     * @memberof Configuration
     */
    A(this, "apiKey");
    /**
     * parameter for basic security
     *
     * @type {string}
     * @memberof Configuration
     */
    A(this, "username");
    /**
     * parameter for basic security
     *
     * @type {string}
     * @memberof Configuration
     */
    A(this, "password");
    /**
     * parameter for oauth2 security
     * @param name security name
     * @param scopes oauth2 scope
     * @memberof Configuration
     */
    A(this, "accessToken");
    /**
     * override base path
     *
     * @type {string}
     * @memberof Configuration
     */
    A(this, "basePath");
    /**
     * base options for axios calls
     *
     * @type {any}
     * @memberof Configuration
     */
    A(this, "baseOptions");
    /**
     * The FormData constructor that will be used to create multipart form data
     * requests. You can inject this here so that execution environments that
     * do not support the FormData class can still run the generated client.
     *
     * @type {new () => FormData}
     */
    A(this, "formDataCtor");
    this.apiKey = t.apiKey, this.username = t.username, this.password = t.password, this.accessToken = t.accessToken, this.basePath = t.basePath, this.baseOptions = t.baseOptions, this.formDataCtor = t.formDataCtor;
  }
  /**
   * Check if the given MIME is a JSON MIME.
   * JSON MIME examples:
   *   application/json
   *   application/json; charset=UTF8
   *   APPLICATION/JSON
   *   application/vnd.company+json
   * @param mime - MIME (Multipurpose Internet Mail Extensions)
   * @return True if the given MIME is JSON, false otherwise.
   */
  isJsonMime(t) {
    const e = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return t !== null && (e.test(t) || t.toLowerCase() === "application/json-patch+json");
  }
}
export {
  W as BankAccountCurrentVaultEnum,
  J as CardType,
  z as ChargeType,
  Z as ChargifyJsLoadOptionsCurrencyEnum,
  X as ChargifyJsLoadOptionsTypeEnum,
  te as ComponentComponentKindEnum,
  ee as ComponentComponentPricingSchemeEnum,
  Be as Configuration,
  re as CouponCompoundingStrategyEnum,
  oe as CouponCouponRestrictionsInnerItemTypeEnum,
  ae as CouponDiscountTypeEnum,
  se as CouponRecurringSchemeEnum,
  ne as CreditCardCurrentVaultEnum,
  we as DefaultApi,
  Y as DefaultApiAxiosParamCreator,
  Le as DefaultApiFactory,
  P as DefaultApiFp,
  ie as InfuraChargifyCoreProductComponentHandles,
  ce as InfuraChargifyCoreProductHandles,
  le as InfuraChargifyFreeProductComponentHandles,
  pe as InfuraChargifyFreeProductHandles,
  de as InfuraChargifyIPFSProductComponentHandles,
  ue as InfuraChargifyIPFSProductHandles,
  me as InfuraChargifyOriginalPricePointHandle,
  he as InfuraChargifyProductFamilyHandles,
  Pe as InvoiceCollectionMethodEnum,
  Ce as InvoiceConsolidationLevelEnum,
  ye as InvoiceStatus,
  be as ItemCategory,
  Oe as MetadataInputItemNameEnum,
  Se as MultipleComponentAllocationInputPaymentCollectionMethodEnum,
  Ve as PaymentType,
  Re as PricePointType,
  Ee as PricingScheme,
  _e as ProductExpirationIntervalUnitEnum,
  Ae as ProductIntervalUnitEnum,
  Ie as ProductTrialIntervalUnitEnum,
  Ue as SubscriptionCancellationMethodEnum,
  fe as SubscriptionInputSubscriptionPaymentCollectionMethodEnum,
  Te as SubscriptionPaymentCollectionMethodEnum,
  ve as SubscriptionState,
  Ne as UpdateSubscriptionInputSubscriptionPaymentCollectionMethodEnum
};
